import React from 'react'
import ReactDragDrawer from 'react-drag-drawer'
import { playSong } from '../../utils/song'
import songsName from '../../enums/songsName'
import { FiX } from 'react-icons/fi'
import { BsArrowLeftCircle } from 'react-icons/bs'
import LogoPng from '../../assets/images/new/logo.webp'

const PrivacyPolicy = (props) => {
  const closeHandler = () => {
    playSong(songsName.TAP)
    props.close()
  }

  return (
    <ReactDragDrawer
      open={props.isOpened}
      onRequestClose={props.close}
      direction="left"
      containerElementClass="h-override"
      modalElementClass="h-override fixed top-0 left-0 z-10"
    >
      <div
        className="w-screen max-w-lg h-override bg-modal flex flex-col justify-start items-start px-4 text-lg"
        style={{
          paddingTop: window.native_app_status_bar_height ?? 16,
          paddingBottom: window.native_app_navigation_bar_height ?? 16
        }}
      >
        <div className="w-full shrink-0 flex flex-row items-center justify-between mb-6">
          <div className="w-full flex flex-row justify-between items-center">
            <div
              className="flex flex-row justify-start items-center cursor-pointer"
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={() => {
                playSong(songsName.TAP)
                props.backToDrawerMenu()
              }}
            >
              <BsArrowLeftCircle className="w-8 h-8 text-pallet-1" />
            </div>

            <img src={LogoPng} className="h-8 mx-auto" alt="Logo" />

            <button
              type="button"
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={closeHandler}
              className="text-black bg-transparent hover:bg-slate-200 rounded-lg text-2xl lg:text-xl"
            >
              <FiX className="w-8 h-8 text-pallet-1" />
            </button>
          </div>
        </div>

        <div
          className="w-full flex-1 overflow-y-auto pb-6"
          style={{
            WebkitOverflowScrolling: 'touch',
            touchAction: 'pan-y'
          }}
        >
          <h2 className="text-pallet-1 font-bold text-xl text-center mx-auto my-8">
            Política de privacidade
          </h2>

          <div className="text-lg">
            <div>
              <p className="font-bold">1. OBJETIVO</p>
              <p className="mt-1">
                A Graviola Digital garante aos Participantes Usuários da Máquina de Contos que está comprometida com o completo atendimento aos termos da Lei Geral de Proteção de Dados (LGPD), que estabelece diretrizes e regulamentações para a coleta, armazenamento, processamento e compartilhamento de dados pessoais. Este termo tem como objetivo dar transparência, esclarecer e divulgar as regras utilizadas pelo aplicativo em relação a informações, de modo que os Participantes Usuários possam escolher se querem ou não fornecer seus dados pessoais para assinar e utilizar a Máquina de Contos.
              </p>
            </div>

            <div className="mt-2">
              <p className="font-bold">2. INFORMAÇÕES COLETADAS E USO</p>
              <p className="mt-1">
                Ao utilizar a Máquina de Contos poderão ser coletadas as informações e dados pessoais abaixo descritos, estritamente para o uso especificado.
              </p>

              <div className="ml-4">
                <p className="mt-2 font-semibold">2.1 Acesso sem login e simples navegação</p>
                <p className="mt-1">
                  O acesso à Máquina de Contos sem autenticação de usuário e navegação pelo conteúdo sem acesso efetivo aos livros não implica solicitação e coleta de dados pessoais dos Participantes Usuários.
                </p>
                <p className="mt-0.5">
                  Durante a navegação na Máquina de Contos poderão ser coletadas, como único objetivo de avaliar a usabilidade do aplicativo, informações gerais tais como tempo de navegação e áreas mais acessadas, sem distinção por usuário dos dados coletados.
                </p>
              </div>

              <div className="ml-4">
                <p className="mt-2 font-semibold">2.2 Associação a uma empresa parceira</p>
                <p className="mt-1">
                  Ao solicitar a associação a uma das empresas parceiras da Máquina de Contos, o Participante Usuário será solicitado a informar dados pessoais de acesso, definidos pela empresa parceira a que está vinculado, capazes de confirmar sua elegibilidade junto à empresa parceira. Estes dados poderão ser: CPF, telefone, e-mail, número/código de cliente, nome de usuário e senha cadastrados na empresa parceira. A Máquina de Contos informará estes dados à empresa parceira para que esta confirme a elegibilidade do Participante Usuário ao vínculo. Em caso negativo, a Máquina de Contos não armazenará nenhum destes dados.
                </p>
              </div>

              <div className="ml-4">
                <p className="mt-2 font-semibold">2.3 Assinatura</p>
                <p className="mt-1">
                  Caso o Participante Usuário opte por fazer uma assinatura, a Máquina de Contos poderá ter acesso a informações pessoais, como nome, data de nascimento e telefone. O sistema de pagamento relacionado ao sistema operacional utilizado pelo seu dispositivo é o responsável pela coleta e armazenamento das informações de pagamento do Participante Usuário, que não são compartilhadas com a Máquina de Contos.
                </p>
              </div>

              <div className="ml-4">
                <p className="mt-2 font-semibold">2.4 Informações do dispositivo</p>
                <p className="mt-1">
                  Para melhorar a experiência do Participante Usuário, recursos e usabilidade, poderão ser coletadas informações como o tipo de dispositivo que utiliza a Máquina de Contos, o sistema operacional e sua versão. Nenhuma informação, acesso ou ação relativa ao dispositivo será coletada ou executada fora das permissões solicitadas na instalação do aplicativo.
                </p>
                <p className="mt-0.5">
                  É importante ressaltar que as informações coletadas são usadas exclusivamente para viabilizar e melhorar a experiência do Participante Usuário e eventualmente oferecer recursos personalizados.
                </p>
              </div>
            </div>

            <div className="mt-2">
              <p className="font-bold">3. DIVULGAÇÃO DE DADOS PESSOAIS PARA AUTORIDADES LEGAIS</p>
              <p className="mt-1">
                A Máquina de Contos, quando solicitada, poderá divulgar seus dados pessoais para:
              </p>
              <p className="ml-4 mt-2">
                a) Autoridades legais e regulatórias, mediante determinação ou para fins de relatar qualquer violação real ou potencial de lei ou regulamento aplicável;
              </p>
              <p className="ml-4 mt-2">
                b) Qualquer parte relevante, agência de aplicação da lei ou tribunal, na medida necessária para o estabelecimento, exercício ou eficácia dos direitos legais;
              </p>
            </div>

            <div className="mt-2">
              <p className="font-bold">4. CONSENTIMENTO</p>
              <p className="mt-1">
                Ao baixar e/ou utilizar a Máquina de Contos, o Participante Usuário, além das permissões concedidas relativas aos acessos ao seu dispositivo, consente com a coleta e o uso de suas informações pessoais de acordo com esta Política de Privacidade.
              </p>
            </div>

            <div className="mt-2">
              <p className="font-bold">5. ALTERAÇÕES NA POLÍTICA DE PRIVACIDADE</p>
              <p className="mt-1">
                Atualizações futuras nesta Política de Privacidade poderão ocorrer de acordo com alterações nas leis e regulamentações pertinentes.
              </p>
              <p className="mt-2">Data da Última Atualização: 01/10/2025</p>
            </div>

            <div className="mt-2">
              <p className="font-bold">6. CONTATO</p>
              <p className="mt-1">
                O Participante Usuário poderá solicitar correção, atualização ou a exclusão de seus dados pessoais, bem como solicitar uma cópia de seus dados pessoais armazenados na Máquina de Contos por meio do canal Fale Conosco.
              </p>
            </div>

            <div className="mt-2">
              <p className="font-bold">7. LEI APLICÁVEL</p>
              <p className="mt-1">
                Esta Política de Privacidade é regida e deverá ser interpretada de acordo com as leis da República Federativa do Brasil.
              </p>
            </div>
          </div>
        </div>
      </div>
    </ReactDragDrawer>
  )
}

export default PrivacyPolicy